import { Controller } from "@hotwired/stimulus";
import { debugLog } from "../utils";

export default class ToggleController extends Controller {
  static targets = ["content"];

  toggle() {
    debugLog("UnhideController: toggle");
    this.contentTarget.classList.toggle("hidden");
  }
}